import "./index.css";
import { createRoot } from "react-dom/client";

const mountFallback = (error: unknown) => {
  const el = document.getElementById("root");
  if (!el) return;

  el.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;font-family:'Tahoma','Verdana','Segoe UI',sans-serif;">
      <div style="max-width:720px;width:100%;">
        <h1 style="font-size:20px;margin:0 0 12px 0;">Technischer Fehler</h1>
        <p style="margin:0 0 16px 0;color:#444;">Die Seite konnte auf diesem Gerät nicht initialisiert werden. Bitte lade neu.</p>
        <button onclick="window.location.reload()" style="padding:10px 14px;border-radius:10px;border:1px solid #ddd;background:#111;color:#fff;cursor:pointer;">
          Neu laden
        </button>
        ${import.meta.env.DEV ? `
        <details style="margin-top:16px;border:1px solid #eee;border-radius:12px;padding:12px;">
          <summary style="cursor:pointer;">Technische Details (nur Dev-Modus)</summary>
          <pre style="white-space:pre-wrap;word-break:break-word;font-size:12px;margin:12px 0 0 0;color:#666;">${String(error ?? "Unbekannter Fehler").replace(/[<>&]/g, (c) => ({"<":"&lt;",">":"&gt;","&":"&amp;"}[c]!))}</pre>
        </details>` : ''}
      </div>
    </div>
  `;
};

(async () => {
  try {
    const rootEl = document.getElementById("root");
    if (!rootEl) throw new Error("Root element #root not found");

    const { default: App } = await import("./App.tsx");
    createRoot(rootEl).render(<App />);
  } catch (error) {
    console.error("App bootstrap failed:", error);
    mountFallback(error);
  }
})();

